import { useCallback, useEffect, useState } from 'react';
import {
  MOCK_TEMPLATES,
  MOCK_ZOHO_ACTIVITY,
  MOCK_ZOHO_FLOWS,
  MOCK_ZOHO_INFO,
} from '../../pages/integrations/zoho-CMR/MockData';
import type {
  Template,
  ZohoActivityData,
  ZohoFlow,
  ZohoFlowsData,
  ZohoInfo,
  ZohoSettings,
} from '../../types/integrations';

export interface UseZohoResult {
  info: ZohoInfo | null;
  loading: boolean;
  error: string;
  reload: () => Promise<void>;
  saveSettings: (settings: ZohoSettings) => Promise<void>;
  disconnect: () => Promise<void>;
}

export function useZoho(): UseZohoResult {
  const [info, setInfo] = useState<ZohoInfo | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    try {
      // const data = await api.get('ZOHO');
      const data = MOCK_ZOHO_INFO;
      setInfo(data);
      setError('');
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Something went wrong');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  const saveSettings = useCallback(async (settings: ZohoSettings) => {
    // await api.saveSettings('ZOHO', settings);
    setInfo((prev) => (prev ? { ...prev, settings } : prev));
  }, []);

  const disconnect = useCallback(async () => {
    // await api.disconnect('ZOHO');
    setInfo((prev) =>
      prev
        ? { ...prev, status: 'NOT_CONNECTED', account: null }
        : prev
    );
  }, []);

  return { info, loading, error, reload: load, saveSettings, disconnect };
}

export interface UseZohoFlowsResult {
  data: ZohoFlowsData | null;
  templates: Template[];
  saveFlow: (key: string, payload: Partial<ZohoFlow>) => Promise<void>;
  testFlow: (key: string, phone: string) => Promise<void>;
}

export function useZohoFlows(): UseZohoFlowsResult {
  const [data, setData] = useState<ZohoFlowsData | null>(null);
  const [templates, setTemplates] = useState<Template[]>([]);

  useEffect(() => {
    // api.flows('ZOHO').then(setData);
    // api.templates().then(setTemplates);
    setData(MOCK_ZOHO_FLOWS);
    setTemplates(MOCK_TEMPLATES);
  }, []);

  const saveFlow = async (_key: string, _payload: Partial<ZohoFlow>) => {
    // await api.saveFlow(key, payload);
  };

  const testFlow = async (_key: string, _phone: string) => {
    // await api.testFlow(key, phone);
  };

  return { data, templates, saveFlow, testFlow };
}

export function useZohoActivity(): { data: ZohoActivityData | null } {
  const [data, setData] = useState<ZohoActivityData | null>(null);
  useEffect(() => {
    // api.activity('ZOHO').then(setData);
    setData(MOCK_ZOHO_ACTIVITY);
  }, []);
  return { data };
}